import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import YSMVL03 from './../workinstructions/images/ysmvl03.png';
import YSMVL0302 from './../workinstructions/images/ysmvl03-02.png';
import YSMVL03data from './../workinstructions/images/ysmvl03data.png';
import FEST01 from './../workinstructions/images/FEST01.png';
import FEST02 from './../workinstructions/images/FEST02.png';
import FEST02A from './../workinstructions/images/FEST02A.png';
import FEST04 from './../workinstructions/images/FEST04.png';
import FEST05 from './../workinstructions/images/FEST05.png';

class RLCGoodsReceive extends React.Component {
    
    componentDidMount() {
		 document.title = "RLC Goods Receive";    
        // Check if there's a hash in the URL and scroll to that section
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1); // Remove the # from hash
            setTimeout(() => {
                const element = document.getElementById(targetId);
                if (element) {
                    // Calculate scroll position with offset to show the heading properly
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - 100; // Adjust this value as needed
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }
    }

    render() {
        return (
            <div>

                <h1 className="page-header">RLC Inbound</h1>
                <Panel>
                    <PanelHeader>RLC Inbound</PanelHeader>
                    <PanelBody>
                    <h2>Inbound</h2>
                        <p>
                            Use ST YSMVL03 =&gt; Scan the barcode in =&gt; or scan the materialcode and serial separately =&gt; Fill in country =&gt; F8 =&gt; From the overview you can determine the type of item
							0093/Identical Repair. If item is unknown with serial, then try with RMA
                        </p>
							<p> <img src={YSMVL03} alt="YSMVL03 first screen" style={{ maxWidth: '100%', height: 'auto' }} /> </p>						
							<p> <img src={YSMVL0302} alt="YSMVL03 second screen" style={{ maxWidth: '100%', height: 'auto' }} /> </p>													
							<p> <img src={YSMVL03data} alt="YSMVL03 second screen wit hdata" style={{ maxWidth: '100%', height: 'auto' }} /> </p>																				
							
                    <h2>Fest registration</h2>
                        <p>
							<p> <img src={FEST01} alt="Fest first screen" style={{ maxWidth: '100%', height: 'auto' }} /> </p>						
							<p> <img src={FEST02} alt="Fest second screen" style={{ maxWidth: '100%', height: 'auto' }} /> </p>													
							<p> <img src={FEST02A} alt="Fest second screen with selector for type" style={{ maxWidth: '100%', height: 'auto' }} /> </p>																															
							<p> <img src={FEST05} alt="Fest second screen with more options to select" style={{ maxWidth: '100%', height: 'auto' }} /> </p>																																
                            Fill in the known data in the fields and select the right choices =&gt; save<br />							
						</p>
                    </PanelBody>
                    <footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
                      <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
                        &copy; Nov 2025 by TQT Tong. All rights reserved.
                      </p>
                    </footer>
                            
                </Panel>
        
            </div>
        )
    }
}

export default RLCGoodsReceive;
















